"use strict";

require("../../style/default.css");
require("./index.css");
require("../../empty/style/css");